<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24.489" height="25" viewBox="0 0 24.489 25">
    <g id="Сгруппировать_4770" data-name="Сгруппировать 4770" transform="translate(0)">
      <g id="Сгруппировать_4768" data-name="Сгруппировать 4768" transform="translate(0 3.145)">
        <path id="Контур_4053" data-name="Контур 4053" d="M1189.022-495.4a2.125,2.125,0,0,1-.447-2.475h-.007a8.942,8.942,0,0,0,2.535-5.878,4.89,4.89,0,0,0-5.053-5.2,4.812,4.812,0,0,0-4.949,5.2,8.848,8.848,0,0,0,2.445,5.894,2.081,2.081,0,0,1-.623,2.459c-2.773,1-6.027,2.821-6.027,4.619v.674c0,2.45,4.767,3.007,9.18,3.007s9.126-.557,9.126-3.007v-.674C1195.2-492.632,1191.932-494.439,1189.022-495.4Z" transform="translate(-1176.896 508.954)" fill="#e1cd9d"/>
      </g>
      <g id="Сгруппировать_4769" data-name="Сгруппировать 4769" transform="translate(11.637)">
        <path id="Контур_4054" data-name="Контур 4054" d="M1427.254-552.8c-.124-.042-.913-.234-.421-1.756h-.006a8.467,8.467,0,0,0,2.17-5.63c0-3.271-2.049-4.986-4.538-4.986a4.244,4.244,0,0,0-4.12,2.73,7.146,7.146,0,0,1,2.51,5.715,11.148,11.148,0,0,1-2.636,6.877c2.147.812,5.5,2.447,6.462,4.944,3.382-.188,6.39-.89,6.39-2.825v-.645C1433.064-550.15,1429.99-551.881,1427.254-552.8Z" transform="translate(-1420.213 565.172)" fill="#e1cd9d"/>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconFriends',
  }
</script>
